<template>
  <base-page
    :title="`Fixture List`"
  >
    <template #actionButton>

    </template>
    <template #main>
      <fixtures-output-table />
    </template>
  </base-page>
</template>
<script>
  import BasePage from "../BasePage"
  import FixturesOutputTable from "../../components/Fixtures/FixturesOutputTable.vue"

  export default {
    components: {
      FixturesOutputTable,
      BasePage,
    },
  }
</script>
